// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lora_2c6ac3', '__Lora_Fallback_2c6ac3', Times New Roman, serif","fontStyle":"normal"},"className":"__className_2c6ac3"};